import React from "react";
import throttle from "lodash/throttle";
import { Toast } from "antd-mobile";
import * as Api from "../../utils/api";
import Md5 from "../../utils/Md5";
import Http from "../../utils/http";
import Utils from "../../utils/utils";

let HttpInstance = new Http();
const utils = new Utils();
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scaleH: 0,
      couponList: [],
      currentCouponId: "",
      currentCoupon: {},
    };
  }
  render() {
    const _this = this;
    return (
      <div className="couponContainer">
        <div className="couponListContainer">
          {_this.state.couponList.length > 0 ? (
            _this.state.couponList.map((item, index) => {
              return (
                <div>
                  {item.available ? (
                    <div
                      className={"couponItemContainer"}
                      key={index}
                      onClick={_this.couponSelect.bind(_this, item)}
                    >
                      {/* <div className="leftContainer">
                                            <div className="couponName">{item.couponName}</div>
                                            <div className="couponValidity">有效期至：{item.timeText}</div>
                                        </div>
                                        <div className="rightContainer" >
                                            {
                                                item.couponType === 2
                                                ?   <div className="priceContainer itemUsedText" >
                                                        <span >{item.discount*10}</span>折
                                                    </div>
                                                :    <div className="priceContainer itemUsedOverdueText">
                                                        <span>{item.money}</span>元
                                                    </div>
                                            }
                                        </div> */}
                      {/* 可用优惠券 */}

                      <div className="couponLeft">
                        <div className="discountContainer">
                          <div>
                            {item.couponType == 1
                              ? item.money
                              : HttpInstance.handleCouponDiscount(
                                  item.discount
                                )}
                          </div>
                          <div>{item.couponType == 1 ? "元" : "折"}</div>
                        </div>
                        <div className="discountLimit">
                          {/* 无限制满减优惠券很划算 */}
                          {item.couponType == 1
                            ? item.limitTop <= 0
                              ? "无限制"
                              : "满" + item.limitTop + "元可用"
                            : item.limitTop <= 0
                            ? "无限制"
                            : "最高抵扣" + item.limitTop + "元"}
                        </div>
                      </div>
                      <div className="couponRight">
                        <div className="couponDescribe">
                          <div className="title">{item.couponName}</div>
                          <div className="limitContainer">
                            <div>使用范围：{item.scopeOfApplication}</div>
                            <div>
                              有效期至：
                              {item.termOfValidity == 0
                                ? "永久有效"
                                : HttpInstance.formatTime(
                                    item.effectiveEndTime,
                                    "Y-M-D"
                                  )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            item.id == _this.state.currentCouponId
                              ? "selectCoupon couponItemSelected"
                              : "selectCoupon"
                          }
                        ></div>
                      </div>
                    </div>
                  ) : (
                    // 不可使用优惠券样式显示
                    <div className={"couponItemContainer"} key={index}>
                      <div className="couponLeft">
                        <div className="disabledDiscountContainer">
                          <div>
                            {item.couponType == 1
                              ? item.money
                              : HttpInstance.handleCouponDiscount(
                                  item.discount
                                )}
                          </div>
                          <div>{item.couponType == 1 ? "元" : "折"}</div>
                        </div>
                        <div className="disabledDiscountLimit">
                          {item.couponType == 1
                            ? item.limitTop <= 0
                              ? "无限制"
                              : "满" + item.limitTop + "元可用"
                            : item.limitTop <= 0
                            ? "无限制"
                            : "最高抵扣" + item.limitTop + "元"}
                        </div>
                      </div>
                      <div className="couponRight">
                        <div className="disabledCouponDescribe">
                          <div className="title">{item.couponName}</div>
                          <div className="limitContainer">
                            <div>使用范围：{item.scopeOfApplication}</div>
                            <div>
                              有效期至：
                              {item.termOfValidity == 0
                                ? "永久有效"
                                : HttpInstance.formatTime(
                                    item.effectiveEndTime,
                                    "Y-M-D"
                                  )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="couponNoImageContainer">
              <img
                src={require("../../assets/images/no_coupon.png")}
                className="no_coupon_bg"
                mode="widthFix"
              />
              <div>暂无优惠券</div>
            </div>
          )}
        </div>
        <div className="fixButtonContainer">
          <button
            className="btn btn-coupon"
            onClick={_this.submitSelect.bind(_this)}
          >
            确定
          </button>
        </div>
      </div>
    );
  }
  componentWillMount() {
    const _this = this;
    document.title = "选择优惠券";
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo.coupon) {
      if (userInfo.coupon.couponType) {
        _this.setState({
          currentCouponId: userInfo.coupon.id,
          currentCoupon: userInfo.coupon,
        });
      }
    }
    _this.queryCoupons();

    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    if (!isApp) {
      utils.wxShareConfig(_this, isApp);
    }
  }
  /**
   * 查询优惠券
   */
  queryCoupons() {
    const _this = this;
    let productID = HttpInstance.getSearchByName(
      this.props.location.search,

      "productID"
    );
    let params = {};
    params.prodId = productID;
    params.isEnsemble = false;
    let response = HttpInstance.post(Api.QUERY_AVAILABLE_API, params);
    // let params = {};
    // params.status = 0;
    // params.pageIndex = 1;
    // params.pageSize = 10;
    // let response = HttpInstance.post(Api.QUERY_COUPON_API, params);
    response.then((data) => {
      console.log("查询可用优惠券", response);
      let responseData = data.data;
      if (responseData.result) {
        let couponList = responseData.data;
        if (couponList.length > 0) {
          couponList = couponList.map((item, index) => {
            // item.timeText = HttpInstance.formatTime(
            //   item.effectiveEndTime,
            //   "Y-M-D"
            // );
            // 处理优惠券使用范围
            switch (item.scopeOfApplication) {
              case 0:
                item.scopeOfApplication = "无限制（会员除外）";
                break;
              case 1:
                item.scopeOfApplication = "视频课程";
                break;
              case 2:
                item.scopeOfApplication = "沙龙听书";
                break;
              case 3:
                item.scopeOfApplication = "医学生";
                break;
              case 4:
                item.scopeOfApplication = "合集";
                break;
              case 5:
                item.scopeOfApplication = item.courseOrBookName;
                break;
              case 6:
                item.scopeOfApplication = item.courseOrBookName;
                break;
            }
            console.log(item);
            return item;
          });
        }

        _this.setState({
          couponList: couponList,
        });
      }
    });
  }
  /**
   * 选择优惠券
   * */
  couponSelect(item) {
    const _this = this;
    if (_this.state.currentCouponId == item.id) {
      _this.setState({
        currentCouponId: "",
        currentCoupon: {},
      });
    } else {
      _this.setState({
        currentCouponId: item.id,
        currentCoupon: item,
      });
    }
  }
  /**
   * 确认选择 */
  submitSelect() {
    const _this = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    userInfo.coupon = _this.state.currentCoupon;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    _this.props.history.go(-1);
  }
}
